<template>
  <div class="login-vue" :style="bg">
    <div class="container">
      <p class="title">WELCOME</p>
      <div v-if="switchover" class="input-c">
        <Input
          prefix="ios-contact"
          v-model="account"
          placeholder="用户名"
          clearable
        />
        <p class="error"></p>
      </div>
      <div v-if="switchover" class="input-c">
        <Input
          type="password"
          v-model="pwd"
          prefix="md-lock"
          placeholder="密码"
          clearable
        />
        <p class="error"></p>
      </div>
      <div v-if="switchover" style="position: relative" class="input-c">
        <Input
          style="width: 58%; float: left"
          type="text"
          v-model="code"
          prefix="md-lock"
          placeholder="验证码"
          clearable
        />
        <img
          :src="showCode"
          style="position: absolute; height: 31px; right: 0"
          @click="GetCode"
        />
      </div>
      <div v-if="!switchover" class="input-c">
        <Input
          prefix="ios-contact"
          v-model="account"
          placeholder="手机号"
          clearable
        />
        <p class="error"></p>
      </div>
      <div v-if="!switchover" style="position: relative" class="input-c">
        <Input
          style="width: 58%; float: left"
          type="text"
          v-model="code"
          prefix="md-lock"
          placeholder="验证码"
          clearable
        />
        <div
          v-if="verifytime <= 0"
          style="position: absolute; height: 31px; right: 0; line-height: 31px"
          @click="AcAquire"
        >
          获取验证码
        </div>
        <div
          v-if="verifytime > 0"
          style="position: absolute; height: 31px; right: 0; line-height: 31px"
        >
          重新获取{{ verifytime }}s
        </div>
      </div>
      <Button
        :loading="isShowLoading"
        class="submit"
        type="primary"
        style="margin-top: 27px"
        @click="submit"
        >登陆</Button
      >
      <p class="account">
        <span @click="register">切换登陆方式</span> |
        <span @click="modal1 = true">忘记密码</span>
        <Modal width="450" v-model="modal1" title="忘记密码" @on-ok="forgetPwd">
          <div style="text-align: center; margin-top: 10px">
            手机号：
            <Input v-model="phone" placeholder="手机号" style="width: 300px" />
          </div>
          <div style="text-align: center; margin-top: 10px">
            验证码：
            <Input v-model="code" placeholder="验证码" style="width: 150px" />
            <span
              v-if="Passwordtime <= 0"
              style="display: inline-block; width: 150px"
              @click="forgetPassword"
              >获取验证码</span
            >
            <div
              v-if="Passwordtime > 0"
              style="display: inline-block; width: 150px"
            >
              重新获取{{ Passwordtime }}s
            </div>
          </div>
          <div style="text-align: center; margin-top: 10px">
            新密码：
            <Input
              v-model="newPwd"
              placeholder="新密码"
              type="password"
              style="width: 300px"
            />
          </div>
        </Modal>
      </p>
    </div>
    <footer style="position: fixed; bottom: 15px">
      <p><span class="glyphicon glyphicon-phone-alt"></span>400-116-5661</p>
      <p>地址：河北省唐山市路南区长青里万达广场24楼1905号</p>
      <p>
        河北卡鱼信息科技有限公司&nbsp;&nbsp;&nbsp;&nbsp;

        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
          冀ICP备18035764号
        </a>
      </p>
    </footer>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "login",
  data() {
    return {
      newPwd: "",
      code: "",
      phone: "",
      modal1: false,
      switchover: true,
      account: "",
      pwd: "",
      verifytime: 0,
      Passwordtime: 0,
      showCode: "/api/getImgCapt",
      pwdError: "",
      code: "",
      isShowLoading: false,
      bg: {},
    };
  },
  created() {
    this.bg.backgroundImage =
      "url(" + require("../assets/imgs/background.png") + ")";
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  mounted() {
    document.onkeydown = (e) => {
      if (e.keyCode === 13) {
        this.submit(); //这里调用的是点击按钮登录的事件
      }
    };
  },
  methods: {
    GetCode() {
      this.showCode = "/api/getImgCapt?d=" + Math.random();
    },

    register() {
      this.switchover = !this.switchover;
    },
    forgetPwd() {
      api
        .ResetPwd({
          phone: this.phone,
          code: this.code,
          newPwd: this.newPwd,
        })
        .then((res) => {
          this.$layer.alert(res.body.message);
        });
    },
    AcAquire() {
      this.verifytime = 120;

      api.GetSmsCapt(this.account).then((res) => {
        if (res.body.message) {
          this.$layer.alert(res.body.message);
        }
        if (res.body.status != 1) {
          this.verifytime = 0;
        } else {
          setInterval(() => {
            this.verifytime--;
          }, 1000);
        }
      });
    },
    forgetPassword() {
      this.Passwordtime = 120;

      api.GetSmsCapt(this.phone).then((res) => {
        if (res.body.message) {
          this.$layer.alert(res.body.message);
        }
        if (res.body.status != 1) {
          this.Passwordtime = 0;
        } else {
          setInterval(() => {
            this.verifytime--;
          }, 1000);
        }
      });
    },
    getNotifyGetMsg() {
      setInterval(() => {
        api.NotifyGetMsg().then((res) => {
          this.$Message.info({
            render: (h) => {
              return h("span", [res.body.data[0]]);
            },
            duration: 1000000,
            closable: true,
          });
        });
      }, 600000);
    },
    submit() {
      var data = {};
      if (!this.switchover) {
        data = {
          phone: this.account,
          code: this.code,
        };
      } else {
        data = {
          phone: this.account,
          password: this.pwd,
          code: this.code,
        };
      }
      api.Login(data).then((res) => {
        if (res.body.status == 1) {
          if (!res.body.data.lastLoginTime) {
            this.$layer.alert("首次登录请前往设置修改密码！");
          }
          this.isShowLoading = true;
          // 登陆成功 设置用户信息
          localStorage.setItem(
            "userImg",
            "https://avatars3.githubusercontent.com/u/22117876?s=460&v=4"
          );
          this.getNotifyGetMsg();
          localStorage.setItem("groupName", res.body.data.groupName);
          localStorage.setItem("userId", res.body.data.id);
          localStorage.setItem("master", res.body.data.master);
          localStorage.setItem("userName", res.body.data.username);
          // 登陆成功 假设这里是后台返回的 token
          localStorage.setItem("token", "i_am_token");
          this.$router.push({ path: this.redirect || "/" });
        } else {
          this.$layer.alert(res.body.message);
        }
      });
    },
  },
};
</script>

<style>
.login-vue {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.login-vue .container {
  background: rgba(255, 255, 255, 0.5);
  width: 300px;
  text-align: center;
  border-radius: 10px;
  padding: 30px;
}
.login-vue .ivu-input {
  background-color: transparent;
  color: #fff;
  outline: #fff;
  border-color: #fff;
}
.login-vue ::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue ::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue :-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgba(255, 255, 255, 0.8);
}
.login-vue .title {
  font-size: 16px;
  margin-bottom: 20px;
}
.login-vue .input-c {
  margin: auto;
  width: 200px;
}
.login-vue .error {
  color: red;
  text-align: left;
  margin: 5px auto;
  font-size: 12px;
  padding-left: 30px;
  height: 20px;
}
.login-vue .submit {
  width: 200px;
}
.login-vue .account {
  margin-top: 30px;
}
.login-vue .account span {
  cursor: pointer;
}
.login-vue .ivu-icon {
  color: #eee;
}
/* .login-vue .ivu-icon-ios-close-circle {
  color: #777;
} */
</style>


